<template>
  <div style="background-color: #10184d;">
    <div class="act-bg" style="display: flex;flex-direction: column;align-items: center;justify-items: center;">
      <div class="act-header">
        <img class="act-sub-title-first" :src="baseUrl + 'vip-alert.png'" />
        <img class="act-main-title" :src="baseUrl + 'xingji.png'" />
        <img class="act-sub-title-second" :src="baseUrl + 'butie.png'" />
      </div>
      <img @click="toGoodsDetail(10877261)" style="width: 93%;margin-left: -9px;margin-bottom: 6px" :src="baseUrl + 'special-goods.png'">
      <div class="act-area" :style="{ marginTop: index.marginTop }" v-for="index in areaList">
        <!--        <img class="act-area-title" :src="baseUrl+index.titleBg" alt="">-->
        <div class="x-three">
          <div class="act-goodsInfo" v-for="item in index.goodsList" @click="toGoodsDetail(item.goodsId)">
            <img class="goodsImg" :style="{ marginTop: item.marginTop }" :src="baseUrl + item.goodsImg" alt="">
          </div>
        </div>
        <!--        <img class="a1" style="margin-top: 5px;width: 33%;" :src="baseUrl+index.footerBg">-->
      </div>
      <img class="act-main-footer" :src="baseUrl + 'zsgo-logo.png'" />
    </div>
  </div>
</template>
<script>
import { getDetail } from '@/utils/api/vipEnjoyApi';
import { toGoodsDetail } from '@/utils/InteractionWithJs';
import { addLog } from "../../../utils/commonApi";
import {getUrlQueryValueByKey} from "@/utils/util";

export default {
  data() {
    return {
      baseUrl: "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/xingji/",
      areaList: [
        {
          goodsList: [
            { "goodsId": 10877183, "goodsImg": "27191.png", "marginTop": "6px" },
            { "goodsId": 10877184, "goodsImg": "27192.png", "marginTop": "-10px" },
          ]
        },
        {
          goodsList: [
            { "goodsId": 10877180, "goodsImg": "27193.png", "marginTop": "6px" },
            { "goodsId": 10877182, "goodsImg": "27194.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877258, "goodsImg": "23991.png", "marginTop": "6px" },
            { "goodsId": 10877176, "goodsImg": "23992.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877259, "goodsImg": "23993.png", "marginTop": "6px" },
            { "goodsId": 10877177, "goodsImg": "23994.png", "marginTop": "-10px" },
          ]
        },
        {
          goodsList: [
            { "goodsId": 10877172, "goodsImg": "21591.png", "marginTop": "6px" },
            { "goodsId": 10877174, "goodsImg": "21592.png", "marginTop": "-10px" },
          ]
        },
        {
          goodsList: [
            { "goodsId": 10877170, "goodsImg": "21593.png", "marginTop": "6px" },
            { "goodsId": 10877171, "goodsImg": "21594.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877173, "goodsImg": "21595.png", "marginTop": "6px" },
            { "goodsId": 10877169, "goodsImg": "21596.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877182, "goodsImg": "15991.png", "marginTop": "6px" },
            { "goodsId": 10877181, "goodsImg": "15992.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877179, "goodsImg": "15993.png", "marginTop": "6px" },
            { "goodsId": 10877180, "goodsImg": "15994.png", "marginTop": "-10px" },
          ]
        },
        {
          goodsList: [
            { "goodsId": 10877175, "goodsImg": "13591.png", "marginTop": "6px" },
            { "goodsId": 10877262, "goodsImg": "13592.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877535, "goodsImg": "13593.png", "marginTop": "6px" },
            { "goodsId": 10877264, "goodsImg": "13594.png", "marginTop": "-10px" },
          ]
        }, {
          goodsList: [
            { "goodsId": 10877265, "goodsImg": "13595.png", "marginTop": "6px" },
            { "goodsId": 10877263, "goodsImg": "13596.png", "marginTop": "-10px" },
          ]
        },
      ]
    }
  },
  mounted() {
    // this.getDetail()
    const actId = getUrlQueryValueByKey(location.href, "actId") || getUrlQueryValueByKey(location.href, "pageFlg") || '';
    const accessRefer = getUrlQueryValueByKey(location.href, "accessRefer") || '';
    //埋点
    addLog(accessRefer, '23-11-3', actId);
  },
  methods: {
    toGoodsDetail(goodsId) {
      toGoodsDetail(0, goodsId);
    },
    async getDetail() {
      const { errno, data, errmsg } = await getDetail();
      if (!errno) {
        this.goodsList = data
      }
    }
  }
}
// document.title = '订阅会员尊享';
</script>
<style scoped>
.act-bg {
  background-image: url("https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/xingji/bg.png");
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  z-index: 0;
}


.act-main-title {
  margin-top: 20px;
  width: 80%;
}

.act-sub-title-first {
  margin-top: 30px;
  width: 28%;
}

.act-sub-title-second {
  margin-top: 10px;
  width: 4.38rem;
}

.act-area {
  position: relative;
  width: 92%;
  z-index: 1;
}

.act-area .x-three {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.act-area .x-three .act-goodsInfo {
  flex: 1;
}

.act-area .x-three .act-goodsInfo img {
  width: 96%;
}

.act-main-footer {
  margin-top: .6rem;
  margin-bottom: .75rem;
  width: 20%;
}
</style>
